// eslint-disable-next-line import/no-import-module-exports
import React from 'react';

function AgeRestriction({ item, className = 'age-restriction' }) {
  // eslint-disable-next-line max-len
  return item.get_age_restriction_display ? <span className={className}>{ item.get_age_restriction_display }</span> : null;
}

module.exports = {
  AgeRestriction,
};
